module.exports = __webpack_public_path__ + "img/logo.8b4d22e1.png";